import React,{useId,useMemo} from 'react';

const FALLBACK=`AED AFN ALL AMD ANG AOA ARS AUD AWG AZN BAM BBD BDT BGN BHD BIF BMD BND BOB BOV BRL BSD BTN BWP BYN BZD CAD CDF CHE CHF CHW CLF CLP CNY COP COU CRC CUC CUP CVE CZK DJF DKK DOP DZD EGP ERN ETB EUR FJD FKP GBP GEL GHS GIP GMD GNF GTQ GYD HKD HNL HRK HTG HUF IDR ILS INR IQD IRR ISK JMD JOD JPY KES KGS KHR KMF KPW KRW KWD KYD KZT LAK LBP LKR LRD LSL LYD MAD MDL MGA MKD MMK MNT MOP MRU MUR MVR MWK MXN MXV MYR MZN NAD NGN NIO NOK NPR NZD OMR PAB PEN PGK PHP PKR PLN PYG QAR RON RSD RUB RWF SAR SBD SCR SDG SEK SGD SHP SLE SLL SOS SRD SSP STN SVC SYP SZL THB TJS TMT TND TOP TRY TTD TWD TZS UAH UGX USD USN UYI UYU UYW UZS VED VES VND VUV WST XAF XAG XAU XBA XBB XBC XBD XCD XDR XOF XPD XPF XPT XSU XTS XUA XXX YER ZAR ZMW ZWL`.split(/\s+/);

function codes(){
  try{
    const x=Intl.supportedValuesOf?.('currency');
    if(x?.length)return x;
  }catch{}
  return FALLBACK;
}

export default function CurrencySelect({value,onChange,required=false,disabled=false,name,placeholder='Search currency…'}){
  const id=useId().replace(/:/g,'');
  const options=useMemo(()=>{
    let names=null;
    try{names=new Intl.DisplayNames([navigator.language||'en'],{type:'currency'})}catch{}
    return codes().map(code=>({code,label:names?.of(code)||code}));
  },[]);
  return <>
    <input
      list={`currencies-${id}`}
      value={value||''}
      name={name}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      autoComplete="off"
      onChange={e=>onChange?.(e.target.value.toUpperCase())}
    />
    <datalist id={`currencies-${id}`}>
      {options.map(x=><option key={x.code} value={x.code}>{x.label}</option>)}
    </datalist>
  </>;
}
